import Vue from "vue";
import App from "./App.vue";
import VueSwal from "vue-swal";
import vuetify from "./plugins/vuetify";
import "@/assets/css/tailwind.css";
import { store } from "./store/store.js";
import router from "./router.js";
import Toasted from "vue-toasted";
import VueExcelXlsx from "vue-excel-xlsx";
import VueElementLoading from "vue-element-loading";
import VueCountdown from "@chenfengyuan/vue-countdown";

Vue.use(VueExcelXlsx);
Vue.component(VueCountdown.name, VueCountdown);
Vue.component("VueElementLoading", VueElementLoading);
Vue.use(Toasted);
import CircularCountDownTimer from "vue-circular-count-down-timer";
Vue.use(CircularCountDownTimer);
Vue.config.productionTip = false;
Vue.use(VueSwal);

Vue.prototype.$baseUrl = "https://96dc-197-210-8-195.ngrok-free.app/api/v1";
if (window.location.hostname == "localhost") {
  Vue.prototype.$baseUrl = "http://localhost:7278/api/v1";
}

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
